module.exports = __webpack_public_path__ + "static/media/ConnectSolveDevelope_2.42f53551.png";